/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Photo } from './GatewayV1Hero.types';

interface LayoutMdProps {
    images: Photo[];
}

export function LayoutMd({ images = [] }: LayoutMdProps) {
    const image1 = images[0] || {};
    const image2 = images[1] || {};
    const image3 = images[2] || {};

    const image1Style = image1.url
        ? { backgroundImage: `url(${image1.url})` }
        : undefined;
    const image2Style = image2.url
        ? { backgroundImage: `url(${image2.url})` }
        : undefined;
    const image3Style = image3.url
        ? { backgroundImage: `url(${image3.url})` }
        : undefined;

    return (
        <div className="gateway-v1-hero-layout md">
            <div
                className="photo hero"
                style={image1Style}
                role="img"
                aria-label={image1.altText}
            />
            <div className="gallery-wrapper">
                <div className="stack">
                    <div
                        className="photo gallery one"
                        style={image2Style}
                        role="img"
                        aria-label={image2.altText}
                    />

                    <div
                        className="photo gallery two"
                        style={image3Style}
                        role="img"
                        aria-label={image3.altText}
                    />
                </div>
            </div>
        </div>
    );
}
